module.exports = __webpack_public_path__ + "media/emojis/low_confidence_disabled-4d1c0f60.svg";